import styled from 'styled-components';

export const Fake = styled.div`
  @keyframes loader {
    0% {
        background-color: rgba(165, 165, 165, 0.1);
    }
    50% {
        background-color: rgba(165, 165, 165, 0.3);
    }
    100% {
        background-color: rgba(165, 165, 165, 0.1);
    }
}

  @-webkit-keyframes loader {
      0% {
          background-color: rgba(165, 165, 165, 0.1);
      }
      50% {
          background-color: rgba(165, 165, 165, 0.3);
      }
      100% {
          background-color: rgba(165, 165, 165, 0.1);
      }
  };

  background-color: #ddd;
  height: ${props => props.height ? `${props.height}px` : '20px'};
  flex: ${props => props.fillContent ? 1 : 'unset'};
  animation: loader 1.5s infinite ease-in-out;
`;

export const SearchArea = styled.div`
  background-color: #ddd;
  border-bottom: 1px solid #ccc;
  padding: 20px 0px;

  .searchBox {
    max-width: 1400px;
    margin: auto;
    background-color: green;
    padding: 20px 15px;
    border-radius: 5px;
    box-shadow: 1px 1px 1px 0.3px rgba(0, 0, 0, 0.2);
    display: flex;

    form {
      flex: 1;
      display: flex;
      gap: 12px;

      input, select {
        height: 40px;
        border: 0;
        border-radius: 5px;
        outline: 0;
        font-size: 15px;
        color: #000;
      };

      input {
        flex: 1;
        padding: 0 10px;
      };

      select {
        background-color: #fff;
        width: 100px;
        cursor: pointer;
        padding: 0 10px;
      };

      button {
        background-color: rgb(242, 128, 0);
        font-size: 15px;
        border: 0;
        border-radius: 5px;
        color: #fff;
        height: 40px;
        padding: 0 20px;
        cursor: pointer;
        transition: all 0.2s ease-in-out 0s;

        &:hover {
          background-color: #e57706;
        };
      };
    };
  };

  .categoryList {
    max-width: 1400px;
    margin: auto;
    display: grid;
    grid-template-columns: repeat(10, 1fr);
    gap: 15px;
    margin-top: 10px;
    padding: 0 15px;

    .categoryItem {
      flex: 1;
      justify-content: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #333;
      text-decoration: none;
      height: 120px;
      margin: 10px 0;
      transition: all 0.3s ease-in-out 0s;
      border-radius: 16px;
      background: #fff;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
      border: 1px solid rgba(0, 0, 0, 0.05);

      &:hover {
        transform: translateY(-8px);
        box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12);
        border-color: transparent;
      };

      i {
        font-size: 48px;
        margin-bottom: 8px;
        transition: all 0.3s ease-in-out;
      };

      &:hover i {
        transform: scale(1.15);
      };

      span:not(.icon) {
        font-size: 14px;
        text-align: center;
        font-weight: 600;
        letter-spacing: 0.3px;
        transition: color 0.3s ease-in-out;
        color: #333;
        padding: 0 10px;
      };
    };
  };

  @media(max-width: 768px) {
    padding: 40px 15px;

    .searchBox {
      padding: 20px;

      form {
        flex-direction: column;
        gap: 10px;

        input, select, button {
          width: 100%;
        };
      };
    };

    .categoryList {
      grid-template-columns: repeat(3, 1fr);
      gap: 12px;
      margin-top: 20px;
      padding: 0 10px;

      .categoryItem {
        height: 100px;

        i {
          font-size: 40px;
          margin-bottom: 6px;
        }

        span {
          font-size: 12px;
        }
      };
    };
  };

  @media(max-width: 480px) {
    .categoryList {
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;
      
      .categoryItem {
        height: 95px;

        i {
          font-size: 36px;
        }

        span {
          font-size: 11px;
        }
      }
    }
    
    .bannerCarousel {
      grid-template-columns: 1fr;
      gap: 10px;
    }
  }
`;

export const BannerCarousel = styled.div`
  max-width: 1400px;
  margin: 20px auto;
  padding: 0 15px;

  .carouselContainer {
    position: relative;
    width: 100%;
    height: 400px;
    overflow: hidden;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);

    .carouselSlide {
      width: 100%;
      height: 100%;
      animation: fadeIn 0.5s ease-in-out;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }

    .carouselBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      background: rgba(0, 0, 0, 0.5);
      color: white;
      border: none;
      font-size: 40px;
      padding: 10px 20px;
      cursor: pointer;
      z-index: 10;
      transition: background 0.3s ease;
      border-radius: 4px;

      &:hover {
        background: rgba(0, 0, 0, 0.8);
      }

      &.prev {
        left: 20px;
      }

      &.next {
        right: 20px;
      }
    }

    .carouselDots {
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      gap: 10px;
      z-index: 10;

      .dot {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.5);
        cursor: pointer;
        transition: all 0.3s ease;

        &.active {
          background: white;
          width: 30px;
          border-radius: 6px;
        }

        &:hover {
          background: rgba(255, 255, 255, 0.8);
        }
      }
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @media(max-width: 768px) {
    .carouselContainer {
      height: 250px;

      .carouselBtn {
        font-size: 30px;
        padding: 8px 15px;

        &.prev {
          left: 10px;
        }

        &.next {
          right: 10px;
        }
      }

      .carouselDots {
        bottom: 15px;
        gap: 8px;

        .dot {
          width: 10px;
          height: 10px;

          &.active {
            width: 25px;
          }
        }
      }
    }
  }
`;

export const PageArea = styled.div`
  max-width: 1400px;
  padding: 0 16px;

  @media(max-width: 768px) {
    padding: 0 12px;
  };
  margin: 40px auto;
  padding: 0 20px;

  h2 {
    font-size: 28px;
    font-weight: 700;
    color: #2c3e50;
    margin-bottom: 30px;
  };

  .list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 25px;

    .aditem {
      width: 100%;
    };
    
    @media (max-width: 1024px) {
      grid-template-columns: repeat(3, 1fr);
    };
    
    @media (max-width: 768px) {
      grid-template-columns: repeat(2, 1fr);
    };
    
    @media (max-width: 480px) {
      grid-template-columns: 1fr;
    };

    .noAds {
      grid-column: 1 / -1;
      padding: 60px 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #fff;
      border-radius: 16px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

      a {
        font-weight: 600;
        color: #667eea;
        text-decoration: none;
        margin-top: 15px;
        padding: 12px 24px;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: #fff;
        border-radius: 8px;
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(102, 126, 234, 0.3);
        };
      };
    };
  };

  .seeAllLink {
    color: #667eea;
    text-decoration: none;
    font-weight: 600;
    display: inline-block;
    margin-top: 20px;
    transition: all 0.3s ease;

    &:hover {
      color: #764ba2;
    };
  };

  .text {
    margin-top: 30px;
    color: #5a6c7d;
    line-height: 1.6;
  }

  @media(max-width: 768px) {
    padding: 0 15px;
    margin: 30px auto;

    h2 {
      font-size: 22px;
      margin-bottom: 20px;
    };

    .list {
      grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
      gap: 15px;
    };
  };
`;